import React from 'react'
import { useTranslation } from "react-i18next";

const Tr = (props) => {
    const { t } = useTranslation();
    const sp = props.sp;

    const methodLabel = t(`ship_payments.method_${sp.payment_method}`, sp.payment_method || '-');

    return (
        <tr>
            <td>{sp.payment_order_no || '-'}</td>
            <td>{sp.user_id}</td>
            <td><span className={`badge badge-${sp.payment_method}`}>{methodLabel}</span></td>
            <td>{sp.payment_consumed_pt ?? 0}</td>
            <td>{sp.payment_cash_paid_cny ?? 0}</td>
            <td>{sp.payment_wechat_transaction_id || '-'}</td>
            <td>{sp.created_at ? (new Date(sp.created_at)).toLocaleString() : '-'}</td>
        </tr>
    )
}

export default Tr
